import { useState } from "react";
import axios from "axios";
import { syncTerceroaTinvaz } from "../../api/common";

export default function SyncSiigoSuppliers() {
  const [loading, setLoading] = useState(false);
  const [log, setLog] = useState([]);
  const [result, setResult] = useState(null);

  const syncSuppliers = async () => {
    setLoading(true);
    setLog([]);
    setResult(null);

    try {
      const result = await syncTerceroaTinvaz()

      setResult(result.data);
      setLog(result.data.logs || []);

    } catch (error) {
    console.error("Error sincronizando suppliers:", error);
      setLog([
        "❌ Error en sincronización",
        error.response?.data.error || error.message,
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card p-4 w-100">
      <h4>Sincronización SIIGO</h4>
      <p className="text-muted">
        Sincroniza proveedores activos desde SIIGO hacia Tinvaz
      </p>

      <button
        className="btn btn-primary"
        onClick={syncSuppliers}
        disabled={loading}
      >
        {loading ? "Sincronizando..." : "Sincronizar Suppliers"}
      </button>

      {result && (
        <div className="alert alert-success mt-3">
          <strong>Finalizado</strong><br />
          Registros procesados: {result.total}<br />
          Nuevos: {result.inserted}<br />
          Actualizados: {result.updated}
        </div>
      )}

      {log.length > 0 && (
        <div className="mt-3">
          <h6>Log</h6>
          <ul className="small">
            {log.map((l, i) => (
              <li key={i}>{l}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
